import React from 'react';
import styled from 'styled-components';
import Spinner from '../base/Spinner';
import Alert from '../base/Alert';
import * as oh from '../../helpers/output_helpers';
import * as api_helpers from '../../helpers/api_helpers';
import ER from 'error-reporting';

export default class Preload extends React.Component {
    constructor(props) {
        super(props);

        this.Container = styled.div `
            padding: 60px 10%;
            h1{
                font-size: 32px;
                margin-bottom: 40px;
                font-weight: 100;
                display: inline-block;
            }
            h2{
                font-size: 16px;
                margin-bottom: 32px;
            }
            .navigation{
                position: relative;
                .user{
                    cursor: pointer;
                    float: right;
                    margin-top: 8px;
                    font-weight: bold;
                    padding: 8px 8px 6px 16px;
                    transition: all 0.3s;
                    border-radius: 24px;
                    margin-right: -8px;
                    &:HOVER, &.active{
                        color: #fff;
                        background-color: #3f3f3f;
                    }
                    p{
                        display: inline-block;
                        margin-right: 4px;
                    }
                }
            }
            .fade{
                position: fixed;
                top: 0;
                right: 0;
                left: 0;
                bottom: 0;
                background-color: rgba(62, 62, 62, 0);
                transition: all 0.4s;
                pointer-events: none;
                &.active{
                    background-color: rgba(62, 62, 62, 0.3);
                    pointer-events: all;
                }
            }
        `;

        this.state = {
            update: 0
        };
    }

    componentDidMount() {
        api_helpers.fetchSSOSpecs().then((specs) => {
            window.sso.specs = specs;
            this.setState({ //Just to force a redraw when we finally get the specs.
                update: this.state.update + 1
            });
        }).catch((err) => {
            err.additional_message = "Err when fetching sso specs after login.";
            ER.setError(err);
        });
    }

    render() {
        if (!window.sso.hasOwnProperty("specs")) {
            return (
                <this.Container>
                    <Spinner
                        text={oh.translate("loading")}
                    />
                    { this.state.alert ? <Alert params={this.state.alert}/> : null }
                </this.Container>
            );
        }
        return (
            <div>
                { this.props.children }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/base/Preload.jsx